export default {
	section_banner: {
		title: {
			one: 'Receive',
		},
		main_title: {
			one: 'Deposits',
		},
		paragraph: {
			one: 'Receive deposits conveniently with JPWorldPay. Whether it is payments from friends, customers, or business partners, JPWorldPay allows you to accept funds quickly and securely.',
		},
		cta_buttons: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},

	seller_access: {
		label: 'Hassle Free Way',
		title: {
			one: 'The Most',
			two: 'Convenient',
			three: 'Deposit',
		},
		paragraph: {
			one: 'Just send it to the other persons email, and you are done.JPWorldPay makes sending money as easy as sharing an email address-no complicated steps or account details required.	It is a fast, secure, and hassle-free way to transfer funds anytime.',
			two: 'With JPWorldPay, sending money becomes a seamless part of your daily routine. Whether you are paying a friend back, sending a gift, or handling personal transactions, all it takes is an email.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	deposit_recipients: {
		label: 'Notification Of Incoming Payment',
		title: {
			one: 'What The',
			two: 'Recipient Sees',
		},
		paragraph: {
			one: 'In JPWorldPay, the recipient sees a clear notification of the incoming payment, along with details such as the senders name,amount, date, and purpose of the transaction. The interface is user-friendly, making it easy to track and manage received funds instantly and securely.',
		},
	},

	credit_system_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Transfer between ',
			two: 'Tether',
			three: '&',
			four: 'ZIGA',
		},
		paragraph: {
			one: 'Easily transfer funds between Tether and ZIGA with JPWorldPays seamless exchange system. Whether you are converting USDT to USOT or vice versa, the process is quick, secure, and hassle-free. Enjoy real-time transfers, minimal fees, and complete transparency every step of the way.',
		},
		cta_buttons: 'Get Started',
	},
	credit_system_right_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Quick',
			two: '&',
			three: 'Easy',
			four: 'Setup Process',
		},
		paragraph: {
			one: 'If your friend does not have a JPWorldPay account, all they need to do is sign up-it only takes a few minutes. The process is simple, fast, and gets them ready to send or receive payments right away. They can start enjoying secure and convenient transactions instantly.',
		},
		cta_buttons: 'Get Started',
	},

	question_sec: {
		label: 'Salary Process',
		title: {
			one: 'It is Easy To',
			two: 'Send Salaries?',
		},
		paragraph: {
			one: 'Open the app and select "Receive Payment" to get started. This allows you to generate a QR code or share your payment details instantly, making it quick and easy for others to send you money securely.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},
	received_request_sec: {
		label: 'Select A JPWorldPay User',
		title: {
			one: 'Enter ',
			two: 'The Requested ',
			three: 'Amount',
		},
		paragraph: {
			one: 'You can simplify the daily reception of cryptocurrency by instantly creating a link to request assets through JPWorldPay. This streamlined process makes it easy to receive payments quickly and securely, allowing you to manage your transactions with ease. Stay in control of your finances and enjoy seamless transfers every time. With JPWorldPay, managing cryptocurrency has never been simpler.',
			two: 'With JPWorldPay, you can also track all your transactions in real-time, giving you full visibility over your financial activities. Whether you are sending or receiving payments, you will always know exactly where your funds are. Plus, with enhanced security features, your information is kept private and protected, ensuring peace of mind with every transaction. JPWorldPay also provides detailed transaction history, making it easy to review past payments and track spending.',
		},
		cta_buttons: {
			one: 'CREATING A JPWORLDPAY LINK',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
